// Some bits of the HTMLDialogElement api are not generally available or functional with most browsers
// So this just encapsulated all of the uses in one place.
//
export function windowHasHTMLDialogElement() {
    return window.HTMLDialogElement !== undefined;
}
export function hasShowModal(dialogElement) {
    const de = dialogElement;
    return de.showModal !== undefined && typeof (de.showModal) === 'function';
}
export function showModal(dialogElement) {
    dialogElement.showModal?.();
}
